<template lang="html">
  <section class="comp-ctn-docs">
		<div class="ctn-missions">
			<div class="mission" v-for="(mission, key) in missionsWithDocuments" v-bind:key="key">
				<div class="mission-name">
					{{ mission.title }}
				</div>
				<div class="ctn-docs row">
					<tile-doc :doc="doc" v-for="(doc, keyt) in mission.documents" v-bind:key="keyt"/>
				</div>
				<div class="no-docs" v-if="mission.documents.length === 0">
					Pas de documents pour le moment
				</div>
			</div>

			<div class="mission" v-if="othersDocs && othersDocs.length > 0">
				<div class="mission-name">
					Autres
				</div>
				<div class="ctn-docs row">
					<tile-doc :doc="doc" v-for="(doc, keyt) in othersDocs" v-bind:key="keyt"/>
				</div>
			</div>

			<div class="no-missions" v-if="missions.length === 0">
				Pas de missions pour le moment
			</div>
		</div>
  </section>
</template>

<script>
import TileDoc from '@/common/components/tile-doc'
import { mapGetters } from 'vuex'
import emma from '@/common/services/Emma'

export default {
	name: 'MyOperations',
	components: {
		TileDoc
	},
	data () {
		return {
			missions: []
		}
	},
	mounted () {
		emma.get('api/mission').then((result) => {
			this.missions = result.data.missions
		})
	},
	computed: {
		...mapGetters({
			user: 'user'
		}),
		othersDocs () {
			return this.$store.getters.typeDocuments('myOperations').filter((item) => !item.sub_category || item.sub_category === 'null')
		},
		missionsWithDocuments () {
			return this.missions.filter((mission) => mission.documents && mission.documents.length > 0)
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/MyDocuments/MyOperations.vue